import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents/settings/rule-set')({
  beforeLoad: () => getTitleContextSlice('Rule Sets'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
